import axiosClient from "@shared/Axios/client";

const endPoint = "fuel_vendor";
export const CommonServices = {
    fEmpAdding: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fEmpAdding`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fEmpEdit: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fEmpEdit`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fEmpList: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fEmpList`, payload);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    measurments: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/measurments`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    catsList: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/catsList`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    subCatsList: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/subCatsList`, payload);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    productAdding: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/productAdding`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    serviceAdding: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/serviceAdding`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    productUpdate: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/updateProduct`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    serviceUpdate: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/updateService`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    productDelete: async (deleteId) => {
        try {
            const res = await axiosClient.delete(`${endPoint}/deleteProduct/${deleteId}`);
            return res;
        }
        catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    productList: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/productList`, payload);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    serviceList: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/serviceList`, payload);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fRefinaryList: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fRefinaryList`, payload);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getVendorProfile: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/getVendorProfile`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    faddToCart: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/faddToCart`, data);
            return res;
        }
        catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fOrderCheckout: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fOrderCheckout`, data);
            return res;
        }
        catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fcartList: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fcart`, payload);
            return res;
        }
        catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    createOrder: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/forder/create`, data);
            return res;
        }
        catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getOrderList: async (pageNumber, pageSize) => {
        try {
            const res = await axiosClient.get(`${endPoint}/forders?pageNumber=${pageNumber}&pageSize=${pageSize}`);
            return res;
        }
        catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getRefinaryOrderList: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/rorders`, payload);
            return res;
        }
        catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },


    fRefinaryProductList: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fRefinaryProductList`, payload);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    updateInfo: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/updateInfo`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    updateVendorImg: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/updateVendorImg`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fGetAllPickupOrders: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fGetAllPickupOrders`, payload);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    rAgentAdding: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/rAgentAdding`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    rUpdateAgent: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/rUpdateAgent`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },


    getAgents: async (payload) => {
        try {
            const res = await axiosClient.post(`${endPoint}/rgetAgents`, payload);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    changePassword: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/changePassword`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    rassignAgent: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/rassignAgent`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getNotifications: async (page, limit) => {
        try {
            const res = await axiosClient.get(`${endPoint}/getNotifications?pageNumber=${page}&pageSize=${limit}`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    getNotificationCount: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/getNotificationCount`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fGetVendorPromoCodes: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fGetVendorPromoCodes`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fCreatePromoCode: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fCreatePromoCode`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    updatePromoCode: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fupdatePromoCode`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fDeletePromoCode: async (data) => {
        try {
            const res = await axiosClient.post(`${endPoint}/fDeletePromoCode`, data);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

        dashboardDetails: async (data) => {
                    try {
                        const res = await axiosClient.post(`${endPoint}/rFuelDashboard`, data);
                        return res;
                    } catch (err) {
                        console.log(err, "the error");
                        return err;
                    }
                },

                dashboardDetails1: async (data) => {
                    try {
                        const res = await axiosClient.post(`${endPoint}/fDashboard`, data);
                        return res;
                    } catch (err) {
                        console.log(err, "the error");
                        return err;
                    }
                },

    deleteAgent: async (deleteId) => {
        try {
            const res = await axiosClient.delete(`${endPoint}/rDeleteAgent/${deleteId}`);
            return res;
        }
        catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    orderSuccess: async (data) => {
        try {
            const res = await axiosClient.get(`${endPoint}/orderSuccess/${data}`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    OrderDetails: async (data) => {
        try {
            const res = await axiosClient.get(`${endPoint}/orderPaymentDetails/${data}`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    fEmpDelete: async (deleteId) => {
        try {
            const res = await axiosClient.delete(`${endPoint}/fEmpDelete/${deleteId}`);
            return res;
        }
        catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    masterProList: async () => {
        try {
            const res = await axiosClient.get(`${endPoint}/masterProList`);
            return res;
        } catch (err) {
            console.log(err, 'the error');
            return err;
        }
    },

    generateInvoice: async (orderId) => {
            try {
                const res = await axiosClient.get(`${endPoint}/generateInvoice/${orderId}/2`);
                return res;
            } catch (err) {
                console.log(err, 'the error');
                return err;
            }
        },

};